// extracted by mini-css-extract-plugin
export default {"header":"style_header__Cq2ZU","subheader":"style_subheader__8n184","numbers":"style_numbers__qVuWA","floatingLabel":"style_floatingLabel__w-bi2"};